import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {HelpInfo} from '../../../models/help-info.interface';
import {DialogsService} from '../../../services/dialogs.service';

@Component({
  selector: 'app-chart-labels-edit-dialog',
  templateUrl: './chart-labels-edit-dialog.component.html',
  styleUrls: ['./chart-labels-edit-dialog.component.scss']
})
export class ChartLabelsEditDialogComponent implements OnInit {

  @Output()
  updateEvent: EventEmitter<void> = new EventEmitter<void>();

  dialogEditForm = this.formBuilder.group({
    title: [null, Validators.required],
    description: [null, Validators.required],
  });

  get titleControl(): FormControl {
    return this.dialogEditForm.get('title') as FormControl;
  }

  get descriptionControl(): FormControl {
    return this.dialogEditForm.get('description') as FormControl;
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: HelpInfo,
              private dialogRef: MatDialogRef<ChartLabelsEditDialogComponent>,
              private readonly formBuilder: FormBuilder,
              private readonly dialogsService: DialogsService) { }

  ngOnInit(): void {
    if (this.data.comment) {
      this.titleControl.setValue(this.data.comment);
    }
    if (this.data.description) {
      this.descriptionControl.setValue(this.data.description);
    }
  }

  sendEditionRequest(): void {
    const dto: HelpInfo | null = this.getEditionDto();
    if (dto) {
      this.dialogsService.editDialog(dto).subscribe(
        () => {
          this.updateEvent.emit();
          this.closeDialog();
        },
        () => {
          this.closeDialog();
        }
      );
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  private getEditionDto(): HelpInfo {
    return {
      id: this.data.id,
      code: this.data.code,
      comment: this.titleControl.value,
      description: this.descriptionControl.value
    };
  }


}
